import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  const prefersReducedMotion = useReducedMotion();
  const handleScrollToProduct = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelector('#producto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-8 md:pt-20 md:pb-10 px-4 overflow-hidden" data-id="element-124" data-mp="2wj76jzedrfi1">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-125" data-mp="30k0v8uzncybz">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold/20 blur-3xl" data-id="element-126" data-mp="2mt4f43mwq9lt"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 rounded-full bg-forest/10 blur-3xl" data-id="element-127" data-mp="2rrpfq462mvas"></div>
      </div>

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-128" data-mp="3fh0bt8ch81il">
        {/* Pre-headline Pattern Interrupt */}
        <div className="inline-flex items-center justify-center px-4 py-2 mb-8 rounded-full bg-red-50 border border-urgency/20 shadow-sm" data-id="element-129" data-mp="3kb4jxuxhafl9">
          <span className="text-urgency font-bold text-sm md:text-base tracking-wide flex items-center gap-2" data-id="element-130" data-mp="2beq494sfdavv">
            <span className="animate-pulse" data-id="element-131" data-mp="2p63ji6javml3">⚠️</span> ATENCIÓN MUJERES DE MÁS DE
            35 AÑOS:
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-forest leading-tight md:leading-tight mb-6 text-balance" data-id="element-132" data-mp="2z3991ac9n5j7">
          "Descubrí Por Qué Tu Vientre Se Hincha Cada Noche Aunque Comas Sano{' '}
          <span className="text-gold-dark" data-id="element-133" data-mp="384fqblmqokdi">
            — Y El Método de 15 Minutos Que Lo Detiene Mientras Duermes"
          </span>
        </h1>

        {/* Sub-headline */}
        <p className="text-lg md:text-xl text-dark/80 italic font-medium max-w-3xl mb-10" data-id="element-134" data-mp="1dpwpdnhuioxl">
          Sin dietas extremas. Sin pasar hambre. Sin ingredientes raros. Solo
          comida real que tu cuerpo entiende.
        </p>

        {/* Emotional Hook Box */}
        <div className="w-full max-w-2xl bg-white p-6 md:p-8 rounded-2xl shadow-warm border border-gold/20 mb-12 relative" data-id="element-135" data-mp="38v5xlceysav8">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-forest-dark text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-136" data-mp="3irioy3n1ecmt">
            Importante
          </div>
          <p className="text-base md:text-lg font-medium text-dark leading-relaxed" data-id="element-137" data-mp="3rs710ssve2x2">
            <strong className="text-forest" data-id="element-138" data-mp="3rqcqm8f85t78">
              Si te vas a dormir sintiéndote pesada, hinchada y frustrada a
              pesar de "esforzarte"...
            </strong>{' '}
            esta puede ser la página más importante que leerás este año.
          </p>
        </div>

        {/* Product Mockup */}
        <div className="w-full max-w-md mx-auto mb-10 relative group" data-id="element-139" data-mp="edkhxgksikum">
          <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full scale-90 group-hover:scale-100 transition-transform duration-700" data-id="element-140" data-mp="eb7s6h8sj670"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png" alt="Cenas Anti-Inflamatorias en 15 Minutos" className="relative z-10 w-full h-auto drop-shadow-2xl animate-[float_6s_ease-in-out_infinite]" data-id="element-141" data-mp="23uofd3tec5xj" />
        </div>

        {/* Scroll-in subtitle link */}
        <motion.a href="#producto" onClick={handleScrollToProduct} initial={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="group w-full max-w-2xl mx-auto flex flex-col items-center gap-3 text-center cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-4 focus-visible:ring-offset-cream rounded-lg" data-id="element-142" data-mp="1pvor3x9spt1w">
          <span className="block h-px w-16 bg-gold/50" aria-hidden="true" data-id="element-143" data-mp="2l1md0ortvbtu"></span>
          <span className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-forest leading-snug text-balance" data-id="element-144" data-mp="2q2a2v74blmmh">
            ¿Quieres desinflamar tu vientre?{' '}
            <span className="relative inline-block text-gold-dark" data-id="element-145" data-mp="2c4c2x6qqxsqi">
              Lee a continuación porque esto es para vos
              <span className="absolute left-0 -bottom-1 h-[2px] w-full origin-left scale-x-0 bg-gold-dark/60 transition-transform duration-500 group-hover:scale-x-100" aria-hidden="true" data-id="element-146" data-mp="34q4wcpq5jv0m"></span>
            </span>
          </span>
          <ChevronDownIcon size={24} className="text-gold-dark animate-bounce -mt-1" aria-hidden="true" data-id="element-147" data-mp="2v024isuron3v" />
        </motion.a>
      </div>
    </section>;
}